import { getRequest, postRequest, deleteRequest, patchRequest } from "../../shared/api/axiosHandler";
import { toast } from "react-toastify";

export const addToCart = async (products) => {
  try {
    // Fetch latest stock quantity from API (but don't restrict cart updates)
    await getRequest(`/public/products/${products.id}`);
    
    let cart = JSON.parse(localStorage.getItem("cart")) || [];
    const existingProduct = cart.find((p) => p.id === products.id);

    // Validate product data
    if (!products.id || !products.quantity) {
      toast.error("Invalid product data.");
      return;
    }

    // Update quantity if product exists, otherwise add it to cart
    if (existingProduct) {
      existingProduct.quantity += products.quantity;
    } else {
      cart.push({ id: products.id, quantity: products.quantity,slug: products.slug, name: products.name, image: products.image, price: products.price });
    }

    // Update localStorage after changes
    localStorage.setItem("cart", JSON.stringify(cart));

  } catch (error) {
    console.error("Error fetching stock quantity:", error);
    toast.error("Failed to fetch stock data. Please try again.");
  }
};

export const removeItemFromCart = (id) => {
  let cart = JSON.parse(localStorage.getItem('cart')) || [];
  cart = cart.filter(p => p.id !== id);
  localStorage.setItem('cart', JSON.stringify(cart));
}

export const getCart = () => {
  return JSON.parse(localStorage.getItem('cart')) || [];
}

export const clearCart = () => {
  localStorage.removeItem('cart');
}

export const clearCartAfterCheckoutRequest = () => {
  localStorage.removeItem('cart');
}

export const clearCartOnLogin = () => {
  localStorage.removeItem('cart');
}

export const addToCartAuth = async (customerId, productId, quantity) => {
    try {
        return await postRequest("/api/v1/cart", {
            id: {
                customerId: customerId,  // Include customer ID in request
                productId: productId
            },
            quantity: quantity
        }, true);
    } catch (error) {
        throw error;
    }
};

export const getCartAuth = async () => {
    try {
        return await getRequest("/api/v1/cart", {}, true);
    } catch (error) {
        throw error;
    }
};

export const updateCartAuth = async (productId, quantity) => {
    try {
        return await patchRequest("/api/v1/cart", {
            productId: productId,
            itemQuantity: quantity
        }, true);
    } catch (error) {
        throw error;
    }
};

export const deleteCartAuth = async () => {
    try {
        return await deleteRequest(`/api/v1/cart`, {}, true);
    } catch (error) {
        throw error;
    }
};
